var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#52B1CC;}\r\n\t.st1{fill:#73BF93;}\r\n\t.st2{fill:#002E36;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.1,235.6L332.1,235.6c-3-6.2-0.3-13.7,5.9-16.6l13-6.2l-100.9-48.4L149,212.8l13,6.2 c6.2,3,8.9,10.4,5.9,16.6l0,0L142,223.3c-4.1-1.9-6.7-6-6.7-10.5c0-4.5,2.6-8.6,6.7-10.5L245.1,153c3.2-1.5,6.9-1.5,10,0 L358,202.3c4.1,1.9,6.6,6,6.6,10.5c0,4.5-2.6,8.6-6.7,10.5L332.1,235.6L332.1,235.6L332.1,235.6z M352.6,213.6L352.6,213.6 L352.6,213.6L352.6,213.6L352.6,213.6z M147.4,213.6L147.4,213.6L147.4,213.6L147.4,213.6L147.4,213.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.7,346.4c-2.3,1.1-5.1,1.1-7.4,0l-104.6-49.6c-4.1-1.9-6.6-5.9-6.7-10.4c-0.1-4.5,2.4-8.5,6.4-10.5 l25.9-13.1l0,0c3.1,6.1,0.7,13.7-5.5,16.8l-13.2,6.7l101.4,48l101.4-48l-13.2-6.7c-6.2-3.1-8.6-10.6-5.5-16.8l0,0l25.6,12.9 c3.7,1.9,6.4,5.5,6.7,9.6c0.4,4.9-2.2,9.4-6.6,11.5L253.7,346.4L253.7,346.4L253.7,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.3,279.2v-47.7l22.6,11.4c3.1-6.1,0.7-13.7-5.5-16.8l-9.5-4.8l30.7-15.1c-3.1-6.2-10.6-8.7-16.8-5.7 l-21.6,10.6v-3.9c0-5.2-2.3-10.2-6.2-13.6c-4,3.4-6.3,8.4-6.3,13.6v4l-23.3-11c-6.2-3-13.7-0.3-16.7,5.9l32.2,15.2l-9.3,4.7 c-6.2,3.1-8.6,10.6-5.5,16.8l0,0l22.6-11.4v47.6l-50.5-25.6v0.1c0,8.6,4.8,16.4,12.5,20.2l30.5,15.4l-20.8,10.4 c3.1,6.2,10.6,8.6,16.8,5.6l17.9-8.9l17.5,8.9h0c6.2,3.1,13.7,0.7,16.8-5.4l-20.5-10.5l30.5-15.3c7.7-3.9,12.5-11.7,12.5-20.3 L256.3,279.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.c7a2b9c4cec17912d435f94cd48f47ea.svg";
export { ForwardRef as ReactComponent };